import { XRadioButton } from '@adornis/forms/x-radiogroup.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-radiobutton
 */
@customElement('cr-radiobutton')
export class ChromiumRadioButton extends XRadioButton {}
